'use strict';

module.exports = require('./lib/React');



//////////////////
// WEBPACK FOOTER
// ./~/react-owl-carousel/~/react/react.js
// module id = 170
// module chunks = 0